// Texts of the carrier announcement page. The page speaks the carrier's
// language (pl or cs), independent of the language of the main app.
const texts = {
  pl: {
    title: 'Awizacja załadunków',
    intro: 'Uzupełnij numer rejestracyjny, kierowcę i godzinę przyjazdu. OMYA Pomezí od razu widzi Twoje dane.',
    plate: 'Nr rej.',
    driver: 'Kierowca',
    eta: 'Przyjazd',
    save: 'Zapisz',
    noTruck: 'Dziś nie mamy auta',
    saved: 'Zapisano',
    noTruckSaved: 'Zgłoszono: bez auta',
    empty: 'Brak otwartych załadunków.',
    planned: 'Plan',
    demo: 'Demo: dane przykładowe',
  },
  cs: {
    title: 'Avizace nakládek',
    intro: 'Doplňte SPZ, řidiče a čas příjezdu. OMYA Pomezí vaše údaje hned uvidí.',
    plate: 'SPZ',
    driver: 'Řidič',
    eta: 'Příjezd',
    save: 'Uložit',
    noTruck: 'Dnes nemáme auto',
    saved: 'Uloženo',
    noTruckSaved: 'Nahlášeno: bez auta',
    empty: 'Žádné otevřené nakládky.',
    planned: 'Plán',
    demo: 'Demo: ukázková data',
  },
};

export const portalText = (lang) => texts[lang] || texts.cs;
